export const englishWall = `\
-- english bond
-- alternating stretcher and header courses

S = 2
H = 1

S
H
`
